import axios from '@/api/axios';
import { gql } from '@/api/utils';

export default {
  async getUser() {
    try {
      const query = gql`
        query user {
          user {
            __typename
            id
            email
            ... on Administrator {
              status
            }
            ... on PetOwner {
              firstName
              lastName
            }
          }
        }
      `;

      const { user: results } = await axios.post(`/`, { query });
      return results;
    } catch (error) {
      return Promise.reject({
        message: error.message,
      });
    }
  },
  async fetchCity(cityId) {
    try {
      const query = gql`
        query Query($cityId: ID!) {
          city(id: $cityId) {
            id
            logo {
              original
            }
            branding {
              logoImage {
                original
              }
            }
            locales
            currency
            noLicensing
            safeAndHappyFund
            displayHomeSafePage
            displayLicensingPage
            displaySafeAndHappyFundPage
            displayAboutPage
            htmlSafeAndHappyFundLinkTitle
            htmlHomesafeLinkTitle
            htmlLicensingLinkTitle
            customDonationMinAmount
            customDonationMaxAmount
            donationCollectionStatement
          }
        }
      `;

      const variables = { cityId };
      const { city: results } = await axios.post(`/`, { query, variables });
      return results;
    } catch (error) {
      return Promise.reject({
        message: error.message,
      });
    }
  },
};
